import { putApi } from '../api/storeFront';
const updateCart = async (body, logger) => {
    return putApi(body, '/{userId}/cart', logger);
};
export default updateCart;
